const path = {
    testPage: '/test',
    loginPage: '/login'
};

export default path;